document.addEventListener("DOMContentLoaded", function() {
    var button_loadmore = document.querySelector(".custom-filter-load-more"),
        product_list = document.querySelector(".product-list"),
        next_url = product_list.getAttribute("data-next-url");

      if(button_loadmore){
        if(next_url === '')button_loadmore.style.display = "none"
        button_loadmore.addEventListener("click", function() {
          fetch(next_url).then((function(e) {
            if (e.ok) return e.text();
            throw new Error("Network response was not ok.")
          })).then((function(response) {
              var html = document.createElement("div");
            
             var swatch_html = '';
              html.innerHTML = response;
              var response_product_list = html.querySelector(".product-list");
              var response_next_url = response_product_list.getAttribute("data-next-url");
              if(response_next_url === '') button_loadmore.style.display = "none";
              next_url =  response_next_url;
              response_product_list.querySelectorAll('.product-card').forEach(function(i) {
               let tagList = JSON.parse(i.querySelector('[data-product-tagList]').innerText);
               let vendor= i.getAttribute("vendor");
                let style= i.getAttribute("style");
                let currentPrdHandle = i.getAttribute('handle');

                 for (var tag = 0; tag < tagList.tags.length; tag++) {
                  if (tagList.tags[tag].startsWith("Colour:")) {
                    let colourName = tagList.tags[tag].replace('Colour:','');
                    let productHandle = vendor + '-' + style + '-'+ handleize(tagList.tags[tag].replace('Colour:',''));
                    if(currentPrdHandle != productHandle){
                    fetch(`${Shopify.routes.root}products/${productHandle}.js`).then((function(j) {
                    if (j.ok) return j.json();
                    throw new Error("Network response was not ok.")
                    })).then((function(data) {
                      if(data.available){
                      let newPrdColorHex = data.tags.find((tag) => tag.startsWith('#'));
                      swatch_html = '<a href="'+ data.url +'"  data-product-url="'+ data.url +'" style="background:'+newPrdColorHex+'" data-colour-name="'+colourName+'" class="color-swatch  rounded-full color-swatch--sm swatch-'+ productHandle +'"></a>'
                       i.querySelector('.color-swatch-wrapper').insertAdjacentHTML('beforeend',swatch_html);
                      }
                    }));
                    }
                  }
                }
                // console.log(totalCount)
                // if(totalCount > 7 ){
                //   var viewMoreHTML = '<div class="more_label"><a href="products/'+ currentPrdHandle +'" class="reversed-link hover:show"> +'+ (totalCount - 5) +' More</a></div>'
                //   console.log(viewMoreHTML)
                //   i.querySelector('.color-swatch-wrapper').insertAdjacentHTML('beforeend',viewMoreHTML);
                // }
                
               product_list.append(i);
               jdgm.customizeBadges()
             });
          }));
        });
      }
 function handleize(str) {
    str = str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, '-').replace(/^-+|-+$/g, '');
    return str;
  }
});